import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <div class="footer-container">
        <div class="left-col">
          <img src="logo.png" alt="" class="logo"/>
          <div class="social-media">
            <a href="/"><i class="fab fa-facebook-f"></i></a>
            <a href="/"><i class="fab fa-twitter"></i></a>
            <a href="/"><i class="fab fa-instagram"></i></a>
            <a href="/"><i class="fab fa-youtube"></i></a>
            <a href="/"><i class="fab fa-linkedin-in"></i></a>
          </div>
          <p class="rights-text">© 2023 Created By <b>dothasnain</b>  All Rights Reserved.</p>
        </div>
 
        <div class="right-col">
          <h1>Our Newsletter</h1>
          <div class="border"></div>
          <p>Enter Your Email to get our news and updates.</p>
          <form action="" class="newsletter-form">
            <input type="text" class="txtb" placeholder="Enter Your Email"/>
            <input type="submit" class="btn" value="Submit"/>
          </form>
        </div>
      </div>
    </footer>
  )
}

export default Footer
